import { pxToRem } from '@withjoy/joykit/theme';
import { InterFonts } from '@shared/utils/fonts/interFonts';
import { ParticleJoyLogo } from '@shared/components/ParticleJoyLogo';
import { Box, Flex, StyleSystemProps, TextV2, styled } from '@withjoy/joykit';
import { PDP_MOBILE_QUICK_ADD_BAR_HEIGTH } from '@apps/registry/common/components/Catalog/components/ProductDetails/components/ProductQuickAddBar/ProductQuickAddBar.styles';

export const StyledFooter = styled.footer`
  z-index: 1;
  position: relative;
`;

export const ColumnContainer = styled(Box)``;
const columnContainerStyles: StyleSystemProps = {
  maxWidth: {
    __: pxToRem(450),
    md: '100%',
    lg1: pxToRem(1272)
  },
  marginX: 'auto',
  overflow: 'hidden'
};

export const FooterMenuContainer = styled(Box)``;
const footerMenuContainerStyles: StyleSystemProps = {
  backgroundColor: {
    __: 'white',
    md: 'gray2'
  }
};

export const FooterMenuWrapper = styled(Flex)``;
const footerMenuWrapperStyles: StyleSystemProps = {
  rowGap: {
    __: 3,
    md: 4
  },
  alignItems: 'start'
};

export const FooterSubMenuWrapper = styled(Flex)``;
const footerSubMenuWrapperStyles: StyleSystemProps = {
  width: pxToRem(410),
  rowGap: {
    __: 3,
    md: 6
  },
  alignItems: 'start'
};

export const UniversalFooterWrapper = styled(Box)``;
const universalFooterWrapperStyles = (isPdpPage: boolean): StyleSystemProps => ({
  zIndex: 1,
  position: 'relative',
  paddingBottom: {
    _: isPdpPage ? PDP_MOBILE_QUICK_ADD_BAR_HEIGTH : 0,
    sm2: 0
  }
});

export const UniversalFooter = styled(Flex)``;
const universalFooterStyles: StyleSystemProps = {
  width: '100%',
  rowGap: 10
};

export const UniversalFooterContainer = styled(Flex)``;
const universalFooterContainerStyles: StyleSystemProps = {
  width: '100%',
  flexWrap: 'wrap',
  rowGap: {
    __: 10,
    md: 6
  }
};

export const UniversalCtaContainer = styled(Flex)``;
const universalCtaContainerStyles: StyleSystemProps = {
  rowGap: 3,
  columnGap: 4,
  backgroundColor: 'transparent'
};

export const NewFlagText = styled(TextV2)`
  ${InterFonts.subhead};
`;
const newFlagTextStyles: StyleSystemProps = {
  fontWeight: 600,
  paddingX: 2,
  backgroundColor: 'white',
  borderRadius: 1,
  display: 'flex',
  width: pxToRem(41),
  height: pxToRem(20)
};

export const UniversalFooterMenuWrapper = styled(Flex)``;
const universalFooterMenuWrapperStyles: StyleSystemProps = {
  columnGap: 6,
  rowGap: 6,
  alignItems: 'center',
  flexDirection: {
    __: 'column',
    md: 'row'
  }
};

export const FooterCopyrightContainer = styled(UniversalFooterContainer)`
  ${props => props.theme.mediaQueries.up({ viewport: 'md' })} {
    box-shadow: 0px -1px 0px 0px ${({ theme }) => theme.colors.mono12};
  }
`;
const footerCopyrightContainerStyles: StyleSystemProps = {
  flexWrap: 'wrap',
  rowGap: {
    __: 10,
    md: 6
  }
};

export const CopyrightText = styled(TextV2)``;
const copyrightTextStyles: StyleSystemProps = {
  color: 'white'
};

export const UniversalFooterSocialMenuWrapper = styled(Flex)``;
const universalFooterSocialMenuWrapperStyles: StyleSystemProps = {
  columnGap: 6,
  rowGap: 6,
  flexDirection: 'row'
};

export const UniversalFooterLogoContainer = styled(Flex)``;
const universalFooterLogoContainerStyles: StyleSystemProps = {
  rowGap: 10,
  columnGap: pxToRem(28),
  alignItems: {
    _: 'flex-start',
    md: 'center'
  }
};

export const StyledParticleJoyLogo = styled(ParticleJoyLogo)`
  justify-content: center;
  svg,
  canvas {
    width: 89px;
    height: initial;
  }
`;

export const styles = {
  columnContainer: columnContainerStyles,
  footerMenuContainer: footerMenuContainerStyles,
  footerMenuWrapper: footerMenuWrapperStyles,
  footerSubMenuWrapper: footerSubMenuWrapperStyles,
  universalFooterWrapper: universalFooterWrapperStyles,
  universalFooter: universalFooterStyles,
  universalFooterContainer: universalFooterContainerStyles,
  universalCtaContainer: universalCtaContainerStyles,
  newFlagText: newFlagTextStyles,
  universalFooterMenuWrapper: universalFooterMenuWrapperStyles,
  footerCopyrightContainer: footerCopyrightContainerStyles,
  copyrightText: copyrightTextStyles,
  universalFooterSocialMenuWrapper: universalFooterSocialMenuWrapperStyles,
  universalFooterLogoContainer: universalFooterLogoContainerStyles
};
